import { useEffect } from "react";

export const BetterAlone = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div className="modal" style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", overflowY: "auto", zIndex: 1050, }}>
                <div className="modal-content" style={{ padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", maxHeight: "95vh", overflowY: "auto", }}>
                    <div className="img-fluid mb-4">
                        <picture><img src="/media/poemseng/better-alone.jpg" alt=" Better Alone | Lone Wolf writes " style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray", }} /></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>Better Alone</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        Now you're wishing I could stay,<br />
                        But you chose a different way.<br />
                        You never saw the pain I bore,<br />
                        Never gave me a chance to show you more.<br />
                        <br />
                        To me, I was the melody, and you were the song.<br />
                        But In your crazy mind, I was always the wrong.<br />
                        You broke me down and left me alone,<br />
                        Gone in the silence, where I no longer belong.<br />
                        <br />
                        I longed for you with every breath I took,<br />
                        But you were chasing dreams that you mistook.<br />
                        You left behind fleeting moments of joy,<br />
                        Not seeing how deeply I loved, how it destroyed.<br />
                        <br />
                        I wanted to treat you as if you're a queen,<br />
                        still remember those memmories in which you've been.<br />
                        Texted a million times, But you've never seen.<br />
                        I still don't understand why you always act so mean?<br />
                        <br />
                        I loved calling you "Oh, my babe,"<br />
                        My heart was world, You felt it cage.<br />
                        I faced depression at such a young age,<br />
                        Standing alone on an empty stage.<br />
                        <br />
                        I never understood why you were so cold,<br />
                        While my heart felt like it was left to unfold.<br />
                        You built your walls, never letting me in,<br />
                        Leaving me to wonder where we began to spin.<br />
                        <br />
                        I was always there when you came back,<br />
                        But you'd leave me saying, "Don't follow, don't track."<br />
                        This time it's different, I won't pretend,<br />
                        Love in your eyes, I can't comprehend.<br />
                        Now, I’m not strong enough to hear you say,<br />
                        “I’m done, just let it fade away.”<br />
                        <br />
                        Maybe it's better alone,<br />
                        Without the pain, the empty tone.<br />
                        I’ve learned to stand on my own,<br />
                        And in solitude, I’ve finally grown.<br />
                        <br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
